export type CompanyName = 'Lidz' | 'Leadnamics';

export interface SidebarBrand {
  alt: CompanyName;
  label: string;
  src: string;
}

const SIDEBAR_BRANDS: Record<CompanyName, SidebarBrand> = {
  Lidz: { alt: 'Lidz', label: 'LIDZ.ai', src: '/logo-lidz-mini.svg' },
  Leadnamics: { alt: 'Leadnamics', label: 'Leadnamics', src: '/logo-leadnamics-mini.svg' },
};

const getCompanyName = (): CompanyName | undefined => {
  if (typeof window === 'undefined') return undefined;

  try {
    const stored = window.localStorage.getItem('company');
    if (stored === 'Leadnamics' || stored === 'Lidz') return stored;
  } catch {
    return undefined;
  }

  const { hostname } = window.location;
  if (hostname === 'leadnamics.io' || hostname.endsWith('.leadnamics.io')) return 'Leadnamics';
  if (hostname === 'app.lidz.ai' || hostname.endsWith('.lidz.ai')) return 'Lidz';

  return undefined;
};

export const getSidebarBrand = (): SidebarBrand | undefined => {
  const company = getCompanyName();
  return company ? SIDEBAR_BRANDS[company] : undefined;
};
